import { cn } from 'utils/cn.tsx';
import { Pill } from 'components/atoms/Pill.tsx';
import { localize } from 'i18n/localize.ts';
import { loginOpen } from 'signals/login.ts';

const $t = localize();

interface Props {
	className?: string;
	title: string;
	subtitle?: string;
	showLoginButton?: boolean;
	loginOptions?: LoginOptions;
}

export function EmptyStateOverlay({ className, title, subtitle, showLoginButton, loginOptions }: Props) {
	return (
		<div
			data-test="empty-state-overlay"
			className={cn(
				'max-w-full pt-10 font-medium col-span-3 text-center md:absolute md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-[548px] md:bg-white md:rounded-2xl md:p-8 md:shadow-lg',
				className,
			)}
		>
			<div className="text-base font-medium sm:text-xl">{title}</div>
			{subtitle && (
				<p className="text-sm text-balance md:text-base mt-2 text-dark-blue-50 font-medium md:leading-8">
					{subtitle}
				</p>
			)}
			{showLoginButton && (
				<Pill
					className="mt-4 text-sm px-6 py-2 md:mt-6 md:text-lg md:py-3"
					pillType="primary"
					onClick={() => loginOpen(loginOptions ?? {}, { callback: () => {} })}
				>
					{$t.login.action}
				</Pill>
			)}
		</div>
	);
}
